import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RequireQueryParamsGuard {

    private readonly _router = inject(Router);

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | UrlTree {

        const idIntegracao = next.queryParamMap.get('idIntegracao');
        const nome = next.queryParamMap.get('nome');

        if (!idIntegracao || !nome) {
            return this._router.parseUrl('/');
        }

        return true;
    }
}
